import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Row, Col, Button, Modal, ModalBody, Table, Card, CardBody, Collapse } from 'reactstrap'
import { AiOutlineCheck } from 'react-icons/ai'
import { MdAssignment } from 'react-icons/md'
import { FiSend, FiTruck } from 'react-icons/fi'
import { FaFileSignature } from 'react-icons/fa'
import moment from 'moment'

// tracking stock opname (disalin dari modal tracking di pages/Stock/Stock.js)
// data dari stock.detailStock, panggil action stock.getDetailStock sebelum dibuka
class TrackingStock extends Component {
    state = {
        collap: false,
        tipeCol: '',
        history: false
    }

    showCollap = (val) => {
        if (val === 'close') {
            this.setState({ collap: false })
        } else {
            this.setState({ collap: false })
            setTimeout(() => {
                this.setState({ collap: true, tipeCol: val })
            }, 500)
        }
    }

    openHistory = () => {
        this.setState({ history: !this.state.history })
    }

    render() {
        const detailStock = this.props.stock.detailStock || []
        return (
            <>
            <ModalBody>
                <Row className='trackTitle ml-4'>
                    <Col>
                        Tracking Stock Opname Asset
                    </Col>
                </Row>
                <Row className='ml-4 mb-2 trackSub'>
                    <Col md={2}>
                        Kode Area
                    </Col>
                    <Col md={10}>
                    : {detailStock[0] === undefined ? '' : detailStock[0].kode_plant}
                    </Col>
                </Row>
                <Row className='ml-4 mb-2 trackSub'>
                    <Col md={2}>
                        Area
                    </Col>
                    <Col md={10}>
                    : {detailStock[0] === undefined ? '' : detailStock[0].area}
                    </Col>
                </Row>
                <Row className='ml-4 mb-2 trackSub'>
                    <Col md={2}>
                    No Stock Opname
                    </Col>
                    <Col md={10}>
                    : {detailStock[0] === undefined ? '' : detailStock[0].no_stock}
                    </Col>
                </Row>
                <Row className='ml-4 trackSub'>
                    <Col md={2}>
                    Tanggal Pengajuan
                    </Col>
                    <Col md={10}>
                    : {detailStock[0] === undefined ? '' : moment(detailStock[0].tanggalStock === null ? detailStock[0].createdAt : detailStock[0].tanggalStock).locale('idn').format('DD MMMM YYYY ')}
                    </Col>
                </Row>
                <Row className='mt-2 ml-4 trackSub1'>
                    <Col md={12}>
                        <Button color='success' size='md' onClick={this.openHistory}>Full History</Button>
                    </Col>
                </Row>
                <div className="steps d-flex flex-wrap flex-sm-nowrap justify-content-between padding-top-2x padding-bottom-1x">
                    <div className="step completed">
                        <div className="step-icon-wrap">
                            <button className="step-icon" onClick={() => this.showCollap('Submit')} ><FiSend size={40} className="center1" /></button>
                        </div>
                        <h4 className="step-title">Submit Stock Opname</h4>
                    </div>
                    <div className={detailStock[0] === undefined ? 'step' : detailStock[0].status_form > 2 ? "step completed" : 'step'} >
                        <div className="step-icon-wrap">
                            <button className="step-icon" onClick={() => this.showCollap('Pengajuan')}><MdAssignment size={40} className="center" /></button>
                        </div>
                        <h4 className="step-title">Pengajuan Stock Opname</h4>
                    </div>
                    <div className={detailStock[0] === undefined ? 'step' : detailStock[0].status_form !== 9 && detailStock[0].status_form >= 8 ? "step completed" : 'step'}>
                        <div className="step-icon-wrap">
                            <button className="step-icon" onClick={() => this.showCollap('Eksekusi')}><FiTruck size={40} className="center" /></button>
                        </div>
                        <h4 className="step-title">Terima Stock Opname</h4>
                    </div>
                    <div className={detailStock[0] === undefined ? 'step' : detailStock[0].status_form === 8 ? "step completed" : 'step'}>
                        <div className="step-icon-wrap">
                            <button className="step-icon"><AiOutlineCheck size={40} className="center" /></button>
                        </div>
                        <h4 className="step-title">Selesai</h4>
                    </div>
                </div>
                <Collapse isOpen={this.state.collap} className="collapBody">
                    <Card className="cardCollap">
                        <CardBody>
                            <div className='textCard1'>{this.state.tipeCol} Stock Opname</div>
                            <div>Rincian Asset:</div>
                            <Table striped bordered responsive hover className="tableDis mb-3">
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>Nomor Asset</th>
                                        <th>Nama Barang</th>
                                        <th>Merk/Type</th>
                                        <th>Kategori</th>
                                        <th>Status Fisik</th>
                                        <th>Kondisi</th>
                                        <th>Status Aset</th>
                                        <th>Keterangan</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {detailStock.length !== 0 && detailStock.map((item, index) => {
                                        return (
                                            <tr key={item.id}>
                                                <th scope="row">{index + 1}</th>
                                                <td>{item.no_asset}</td>
                                                <td>{item.nama_asset}</td>
                                                <td>{item.merk}</td>
                                                <td>{item.kategori}</td>
                                                <td>{item.status_fisik}</td>
                                                <td>{item.kondisi}</td>
                                                <td>{item.grouping}</td>
                                                <td>{item.keterangan}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                            {detailStock[0] === undefined || this.state.tipeCol === 'Submit' ? (
                                <div></div>
                            ) : (
                                <div>
                                    <div className="mb-4 mt-2">Tracking {this.state.tipeCol} :</div>
                                    {this.state.tipeCol === 'Pengajuan' ? (
                                        <div className="steps d-flex flex-wrap flex-sm-nowrap justify-content-between padding-top-2x padding-bottom-1x">
                                            {detailStock[0].appForm !== undefined && detailStock[0].appForm.length > 0 && detailStock[0].appForm.slice(0).map(item => {
                                                return (
                                                    <div key={item.id} className={item.status === 1 ? 'step completed' : item.status === 0 ? 'step reject' : 'step'}>
                                                        <div className="step-icon-wrap">
                                                        <button className="step-icon"><FaFileSignature size={30} className="center2" /></button>
                                                        </div>
                                                        <h5 className="step-title">{moment(item.updatedAt).format('DD-MM-YYYY')} </h5>
                                                        <h4 className="step-title">{item.jabatan}</h4>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    ) : this.state.tipeCol === 'Eksekusi' && (
                                        <div className="steps d-flex flex-wrap flex-sm-nowrap justify-content-between padding-top-2x padding-bottom-1x">
                                            <div className={detailStock[0].status_form !== 9 && detailStock[0].status_form > 2 ? "step completed" : 'step'}>
                                                <div className="step-icon-wrap">
                                                <button className="step-icon" ><FaFileSignature size={30} className="center2" /></button>
                                                </div>
                                                <h4 className="step-title">Check Data Stock Opname</h4>
                                            </div>
                                            <div className={detailStock[0].status_form !== 9 && detailStock[0].status_form >= 8 ? "step completed" : 'step'}>
                                                <div className="step-icon-wrap">
                                                <button className="step-icon" ><AiOutlineCheck size={30} className="center2" /></button>
                                                </div>
                                                <h4 className="step-title">Selesai</h4>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </CardBody>
                    </Card>
                </Collapse>
            </ModalBody>
            <Modal isOpen={this.state.history} toggle={this.openHistory}>
                <ModalBody>
                    <div className='mb-4'>History Transaksi</div>
                    <div className='history'>
                        {detailStock.length > 0 && detailStock[0].history !== null && detailStock[0].history.split(',').map((item, index) => {
                            return (
                                item !== null && item !== 'null' &&
                                <Button key={index} className='mb-2' color='info'>{item}</Button>
                            )
                        })}
                    </div>
                </ModalBody>
            </Modal>
            </>
        )
    }
}

const mapStateToProps = state => ({
    stock: state.stock
})

export default connect(mapStateToProps)(TrackingStock)
